import React, { useEffect, useState } from 'react';

import { Table } from 'antd';
import { TableCol } from './getTableCol';
import { tableStruct } from './struct';
import { SecureGet } from '../../../services/axiosCall';
import apis from '../../../services/Apis';
import { useNavigate } from 'react-router-dom';
import { facultySortHandler } from '../../../utilities/facultySorting';
import ProfileModal from '../../../components/Modal/ProfileModal';

const { table } = tableStruct;

export const FacultiesTable = () => {
    const [data, setData] = useState([])
    const [sortData, setSortData] = useState([])
    const [pagination, setPagination] = useState({ current: 1, pageSize: 10 });

    const [searchText, setSearchText] = useState('');
    const [searchedColumn, setSearchedColumn] = useState('');

    const [departments, setDepartments] = useState([]);

    const navigate = useNavigate();


    const handleClick = (row) => {
        navigate(`/faculty/${row.id}`, { state: { row, year: new Date().getFullYear() } });
    }

    const columns = [...TableCol(
        handleClick,
        pagination.current,
        pagination.pageSize,
        searchText,
        setSearchText,
        searchedColumn,
        setSearchedColumn,
        departments
    ),
    {
        title: 'Action',
        dataIndex: 'operation',
        render: (_, record) => {

            return (
                <ProfileModal row={record} />
            );
        }
    }
    ];



    const getFaculties = () => {
        SecureGet({ url: apis.FACULTIES })
            .then((response) => {
                setData(response?.data?.results)

                if (response?.data?.results?.length > 0) {
                    // Extract unique departments
                    const uniqueDepartments = [...new Set(response?.data?.results.map(item => item.department))];
                    setDepartments(uniqueDepartments);
                }

            })
            .catch((error) => console.log(error))
    }

    useEffect(() => {
        getFaculties()
    }, [])

    const handleTableChange = (pagination) => {
        setPagination(pagination);
    }


    useEffect(() => {
        if (data?.length > 0) {
            const temp = facultySortHandler(data)
            setSortData(temp ? temp : data)
        }
    }, [data])

    return (
        <>
            {
                sortData?.length > 0 &&
                <Table
                    {...table}
                    columns={columns}
                    dataSource={sortData}
                    pagination={pagination}
                    onChange={handleTableChange}
                />
            }
        </>
    )
}